import { colors } from "constants/theme";
import styled from "styled-components";

const ValidationTitle = styled.h1`
  font-weight: bold;
  letter-spacing: 0.05em;
  font-size: 0.9em;
  text-align: center;
  color: ${colors.text};
  margin: 0.6em 0 0;
`;

export default ValidationTitle;
